import { useEffect } from 'react';

const PUBLIC_SERVICE_URL = 'https://getpaddiq.com/terms';

export function PublicTermsRedirect() {
  useEffect(() => {
    window.location.replace(PUBLIC_SERVICE_URL);
  }, []);

  return (
    <main>
      <h1>Using Paddiq</h1>
      <p>
        <a href={PUBLIC_SERVICE_URL}>Continue to Paddiq service information</a>
      </p>
    </main>
  );
}
